const modes = {};

modes.READ = 'READ';
modes.WRITE = 'WRITE';

export default modes;